const esppressoData = {
  meta: {
    title: "ESPpresso Website Quote",
    clientName: "ESPpresso",
    url: "https://esppresso.com",
    date: "2026-01-06",
    quoteNumber: "Q1-2026-ESP",
    preparedBy: "Jason Toomer",
    summary: [
      "Hi Di, thanks again for the time and discussions around ESPpresso and Vinage Coffee.",
      "This quote covers a Shopify website build for ESPpresso with a highly visual, conversion-focused layout designed to clearly present products and guide customers through to purchase.",
      "It includes product catalogue setup, subscription capability, performance optimisation, and strong SEO foundations to support long-term growth.",
      "Optional Instagram management is available to support ongoing brand visibility and awareness. Content is supplied by you, with content creation by me available as an additional service if required.",
      "Email hosting is included as a yearly recurring item where needed.",
      "",
      "<strong>Summary:</strong>",
      "• Website build for ESPpresso, including logo design and full setup: <strong>$6,100</strong>",
      "• Instagram management for both Vinage Coffee and ESPpresso: <strong>$450 per month</strong>, billed on a rolling three-month basis.",
      "Building consistent presence and awareness across social platforms is important for the success of both websites. Google search alone is unlikely to generate sufficient traction without ongoing visibility and brand reinforcement.",
    ],
  },

  business: {
    name: "2merative Web Design",
    abn: "",
    email: "hello@2merative.com",
    phone: "+61 498 135744",
  },

  gstRate: 0,

  notes: [
    "All pricing is exclusive of GST. GST is not charged as the business is not currently registered for GST.",
    "Owner must provide appropriate access to DNS management for esppresso.com and coffeejourney.com.au to allow website hosting, domain pointing, and deployment to be completed.",
    "Shopify subscription functionality may require a paid third-party subscription app depending on final requirements and platform limitations.",
    "Any third-party app, plugin, or platform fees are paid directly by the owner unless explicitly stated otherwise.",
    "Instagram management is limited to organic activity only. No paid advertising, boosted posts, or ad spend is included.",
    "Instagram management does not guarantee increases in followers, reach, engagement, website traffic, or sales.",
    "Results from social media activity depend on content quality, audience behaviour, platform algorithms, and external factors outside of direct control.",
    "Instagram management may be purchased in advance on a three-month basis and may be terminated with one month’s notice. There is no long-term contractual tie-in beyond this notice period.",
  ],

  assumptionsExclusions: [
    "Owner supplies product list, pricing, variants, and subscription structure.",
    "Owner supplies product images, branding assets, and any Instagram content required for posting unless otherwise agreed.",
    "Instagram management includes scheduling posts and responding to basic engagement only (comments and messages during reasonable business hours).",
    "Instagram management does not include content creation, photography, videography, reels production, copywriting, influencer outreach, giveaways, competitions, or community growth campaigns unless quoted separately.",
    "Copywriting for the website is based on owner-supplied notes. Full copywriting services can be added at an additional cost.",
    "Domain registration, Shopify plan fees, subscription app fees, and email service fees are not included unless explicitly stated.",
  ],

  warrantySupport: [
    "Post-launch website support is available under the included monthly updates or on a pay-as-you-go basis.",
    "Any major scope changes or feature additions will be quoted and approved before work proceeds.",
    "Instagram management is provided as a best-effort service only and does not include any warranty or guarantee of performance, reach, engagement, follower growth, website traffic, or commercial outcomes.",
    "Platform changes, algorithm updates, account restrictions, or third-party actions affecting Instagram performance are outside of my control and are not covered under warranty or support obligations.",
  ],

  acceptance: {
    validUntil: "2026-02-06",
    paymentTerms: "50% deposit to commence. Balance due prior to launch.",
  },

  options: [
    {
      label: "Shopify Website Build (ESPpresso.com)",
      sections: {
        projectApproach: [
          "Design and build a highly visual, image-led Shopify storefront that reflects the ESPpresso brand and guides users through clear, intentional purchase journeys.",
          "Conversion-first structure with prominent calls-to-action, clear product presentation, trust signals, and a simplified path from landing page to checkout.",
          "Subscription-ready setup allowing customers to manage their own coffee plans, including pause, resume, and cancel functionality, subject to the selected Shopify subscription app.",
          "Mobile-first performance optimisation, including responsive layouts, image compression, lazy loading, and layout refinement to support strong Core Web Vitals.",
          "Advanced SEO foundations implemented from launch, including page-level metadata templates, clean URLs, XML sitemap, robots rules, and structured data for products and blog content.",
        ],
        oneOff: [
          { item: "Shopify website build (design + build + setup)", cost: 4200 },
          { item: "Subscription setup (plans + portal configuration)", cost: 500 },
          { item: "Advanced SEO / GEO setup (metadata + schema + sitemap)", cost: 800 },
          { item: "ESPpresso logo design (web + print formats)", cost: 600 },
          { item: "CoffeeJourney.com.au landing page build (included)", cost: 0 },
        ],
        recurring: [
          {
            item: "Website hosting and 1 professional email address",
            costMonthly: 0,
            costYearly: 240,
          },
          {
            item: "Basic website updates included (up to 2 hours per month)",
            costMonthly: 0,
            costYearly: 0,
          },
        ],
      },
    },
    {
      label: "Add-on: Instagram Management (Optional)",
      sections: {
        projectApproach: [
          "2–3 posts per week for ESPpresso and 2–3 posts per week for Coffee Journey (approximately 24 posts per month).",
          "Owner supplies content. If content creation is required, direction must be provided and additional costs may apply.",
        ],
        oneOff: [],
        recurring: [
          { item: "Instagram management (optional add-on)", costMonthly: 450, costYearly: 0 },
        ],
      },
    },
  ],
}

export const quoteData = esppressoData
export default esppressoData
